module.exports = __webpack_public_path__ + "static/media/intro_4.f3f6c279.png";